import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { getData } from "./utils/api";
import { composeWithDevTools } from "redux-devtools-extension";

const INITAIL_STATE = {
  cards: [],
  page: 1,
  loading_filter: false,
  filter_clean: false,
};


// REDUCER

function productsReducer(state = INITAIL_STATE, action) {
  switch (action.type) {
    case "FETCH_CARDS_REQUEST": {
      return {
        ...state,
        loading: true,
      };
    }

    case "FETCH_CARDS_SUCCESS": {
      const { cards } = action.payload;
      return {
        ...state,
        cards,
        loading: false,
      };
    }

    case "FETCH_PAGE": {
      const { data } = action.payload;
      return {
        ...state,
        page: data,
      };
    }
    case "FILTER_FLAG": {
      return {
        ...state,
        loading_filter: true,
      };
    }
    case "FILTER_CLEAN": {
      return {
        ...state,
        filter_clean: true,
      };
    }
    default: {
      return state;
    }
  }
}


// ACTIONS
const fetchCardsRequestAction = () => {
  return { type: "FETCH_CARDS_REQUEST" };
};

const fetchCardsSuccessAction = cards => {
  return { type: "FETCH_CARDS_SUCCESS", payload: { cards } };
};


const fetchFailureAction = error => {
  return { type: "FETCH_FAILURE", payload: error };
};

const fetchPage = (data) => {
  return { type: "FETCH_PAGE", payload: { data } };
};

const fetchFilterFlag = () => {
  return { type: "FILTER_FLAG" };
};

const fetchFilterCleam = () => {
  return { type: "FILTER_CLEAN" };
};






// THUNK

const getCardsRequest = () => {
  return async function(dispatch) {
    try {
      dispatch(fetchCardsRequestAction());
      const cards = await getData();
      console.log("CARDS", cards)
      dispatch(fetchCardsSuccessAction(cards));
    } catch (error) {
      dispatch(fetchFailureAction(error));
    }
  };
};


const getPage = (status) => {
  return async function (dispatch) {
    try {
      dispatch(fetchPage(status));
    } catch (error) {
      dispatch(fetchFailureAction(error));
    }
  };
};

const getFilterFlag = () => {
  return async function (dispatch) {
    try {
      dispatch(fetchFilterFlag());
    } catch (error) {
      dispatch(fetchFailureAction(error));
    }
  };
};

const getFilterClean = () => {
  return async function (dispatch) {
    try {
      dispatch(fetchFilterCleam());
    } catch (error) {
      dispatch(fetchFailureAction(error));
    }
  };
};


const store = createStore(
  productsReducer,
  composeWithDevTools(applyMiddleware(thunk))
);
export {
  store as default,
  getCardsRequest,
  getPage,
  getFilterFlag,
  getFilterClean,
};